import React from 'react'
import PropTypes from 'prop-types'
import { Menu, MenuItem, Button } from '@material-ui/core'
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { hasPermissions } from '../../helpers/AccessControl/AccessControl'

const useStyles = makeStyles(_theme => ({
	button: {
		margin: 8
	},
}))

export default function Actions(props) {
    
    const classes = useStyles()

    const handleAction = (popupState, action) => {
        popupState.close()
        props.onActionSelected(action)
    }

    return (
        <PopupState variant="popover" popupId="demo-popup-menu">
            {popupState => (
                <React.Fragment>
                    <Button
                        className={clsx(classes.button)}
                        variant="contained"
                        {...bindTrigger(popupState)}
                    >
                        Actions
                    </Button>
                    <Menu {...bindMenu(popupState)}>
                        <MenuItem onClick={() => handleAction(popupState, 'donwloadTemplate')}>
                            Download Template (xlsx)
                        </MenuItem>
                        <MenuItem
                            onClick={() => handleAction(popupState, 'uploadEmployees')}
                        >
                            Upload Template (xlsx)
                        </MenuItem>
                        {hasPermissions(['download_employees']) ? <MenuItem onClick={() => handleAction(popupState, 'downloadEmployees')}>
                            Export Employee Data (xlsx)
                        </MenuItem> : null }
                        <MenuItem onClick={() => handleAction(popupState, 'deleteAllEmployees')}>
                            Delete All Employees
                        </MenuItem>
                    </Menu>
                </React.Fragment>
            )}
        </PopupState>
    )
}

Actions.propTypes = {
    onActionSelected: PropTypes.func.isRequired,
}
